import React, { Component } from 'react';
import ModalDialog from '@atlaskit/modal-dialog';
import Footer from './footer';

import Slider from 'react-rangeslider';
// To include the default styles
import 'react-rangeslider/lib/index.css';
import { CircleSlider } from "react-circle-slider";

import 'react-responsive-modal/styles.css';
import "react-tabs/style/react-tabs.css";

import { sendData } from '../../webjam/websocket';
import { displayConsole, sendRequest } from '../../webjam/helper';
import { connect } from '../../base/redux';
import { translate } from '../../base/i18n';
import Settings from './settings';
import Fxtabs from './fxtab';
import {
  closeVideoCall,
  saveRoomEndValue,
  setUsersData,
  setGhostVoiceSync,
  setDelayPanning
} from '../../customise/redux/tool-webjam/actions';
import { getLocalParticipant } from '../../base/participants';

// import solo from './img/solo.png';
// import soloActive from './img/soloActive.png';
// import mute from './img/mute.png';
// import muteActive from './img/muteActive.png';
// import mic from './img/mic.png';
// import micblue from './img/micblue.png';
// import fx from './img/FX.png';
import fxgreen from './img/FXgreen.png';
// import settings from './img/settings.png';
import cross from './img/cross.png';
import abort from './img/abort.png';
import abortRed from './img/abortRed.png';
import radioActive from './img/radioActive.png';
import radioInactive from './img/radioInactive.png';
import axios from 'axios';
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../constant';

import {
  FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3
} from "../../customise/constant"
import { setHybridSession } from '../../customise/redux/tool-webjam/actions';
import { showNotification } from '../../notifications';
import { socketEmit } from '../../../../socket';
import { sendAnalytics } from '../../analytics';
import { getBaseConfig, filterRemoteParticipant, PANNING_VAR, _ValidateIPaddress, dispatch } from '../../customise/Utils';
import Fx from './icon-components/Fx';
import Mute from './icon-components/Mute';
import Solo from './icon-components/Solo';
import Mic from './icon-components/Mic';
import MMute from './icon-components/MMute';
import { setDeviceContainerStatus, showMixerSettingsModal } from '../../customise/redux/tool-webjam-v2/actions';
import { SaveLog } from '../../customise/Utils';
import { Dialog, DialogContent, styled } from '@material-ui/core';
let timeoutFader;

let instrumentArray = [
  'None',
  'Drum Set',
  'Djembe',
  'Electric Guitar',
  'Acoustic Guitar',
  'Bass Guitar',
  'Keyboard',
  'Synthesizer',
  'Grand Piano',
  'Accordion',
  'Vocal',
  'Microphone',
  'Harmonica',
  'Trumpet',
  'Trombone',
  'French Horn',
  'Tuba',
  'Saxophone',
  'Clarinet',
  'Flute',
  'Violin',
  'Cello',
  'Double Bass',
  'Recorder',
  'Streamer',
  'Listener',
  'Guitar+Vocal',
  'Keyboard+Vocal',
  'Bodhran',
  'Bassoon',
  'Oboe',
  'Harp',
  'Viola',
  'Congas',
  'Bongo',
  'Vocal Bass',
  'Vocal Tenor',
  'Vocal Alto',
  'Vocal Soprano',
  'Banjo',
  'Mandolin',
];
import { setConfirmationModalProps, setIsMixerMuteByDefault } from '../../customise/redux/tool-webjam-v3/actions';
import { Tooltip } from '@material-ui/core';
import { ct } from '../../customise/constant-Utils';

class WebjamMixer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      firstname: '',
      device: '',
      usersArr: [],
      selectedIndex: 0,
      sliderReverbValue: 0,
      //sliderPanValue: 0,
      leftReverb: false,
      rightReverb: true,
      openPan: false,
      userIndex: 0,
      scrollClassName: '',
      p2pEnabled: false,
    }
  }

  handleInstrumentList = (e) => {
    try {
      const isSpace = e?.split(" ")?.length > 1;
      let key = e;
      if (isSpace) {
        key = e.replace(" ", "_");
      }
      return ct(`rta-trmc.mixer.instrumentList.${key?.toLowerCase()}`);
    } catch (error) {
      return e;
    }

  }


  componentDidMount() {
    const { usersData, isHybridSession, roomorIpAddress, dispatch, isMixerMuteByDefault } = this.props;
    const users = usersData?.users || [];
    this.setState({
      usersArr: users,
      sliderReverbValue: usersData?.reverbLevel,
      // sliderPanValue: usersData.panLevel,
      leftReverb: usersData?.leftReverb,
      rightReverb: !usersData?.leftReverb,
    });


    // Check if hybrid session(jitsi to jamulus) was activated before change host/change audio mode

    if (isHybridSession) {
      //+ '&server=' + Constant.App.serverVarInHybridsession
      axios.get(Constant.App.ServerUrl + '/status-audio-route?roomname=' + roomorIpAddress)
        .then(response => {
          if (!response.data.processStatus) {
            let isIp = _ValidateIPaddress(roomorIpAddress);
            let hitApi;
            let noChangedRoomName = getBaseConfig('noChangedRoomName')
            if (noChangedRoomName == true) {
              isIp = _ValidateIPaddress(roomorIpAddress);
              hitApi = axios.get(Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + (getBaseConfig("serverVarInHybridsession")) + "&processtype=routing" + `&visibleRoom=${CURRENT_ROOM_NAME}`)
            } else {
              hitApi = axios.get(Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + (getBaseConfig("serverVarInHybridsession")) + "&processtype=routing")
            }
            hitApi.then(e => {
              if (e.data) {
                if (e.data.status) {
                  dispatch(setHybridSession(true, "mixer"));
                  const { id } = this.props.localUser;
                  const session_data = {
                    status: true,
                    location: CURRENT_ROOM_LOCATION,
                    userId: id
                  }
                  socketEmit("hybrid_session", session_data);

                  // BIND NOTIFICATION
                  dispatch(showNotification({
                    titleKey: ct("rta-trmc.mixer.connecting"),
                    descriptionKey: ct("rta-trmc.mixer.sysReady")
                  }));
                } else if (!e.data.status) {
                  // BIND NOTIFICATION
                  dispatch(showNotification({
                    titleKey: ct("rta-trmc.mixer.disconnecting"),
                    descriptionKey: ct("rta-trmc.mixer.disconnectingHybridSession")
                  }));
                }
              }
            }).catch(e => {
              console.log("check audio route mixer start error =>", e)
            })
          }
        }).catch(e => {
          console.log("check audio route mixer status error =>", e)
        })
    }

    // Check status of delay panning with api
    const { delayPanning } = this.props;
    if (delayPanning != PANNING_VAR.DELAY_PANNING) {
      sendRequest({
        url: "/get-panning-status?room=" + roomorIpAddress,
        type: "GET"
      }).then(res => {
        let response = res.data;
        if (response.status) {
          if (response.data.hasOwnProperty("room") && response.data.hasOwnProperty("panning_name")) {
            if (response.data.panning_name == PANNING_VAR.DELAY_PANNING) {

              if (response.data.room == roomorIpAddress) {
                dispatch(setDelayPanning(PANNING_VAR.DELAY_PANNING))

                // const message = {
                //   action: {
                //     uniqueID: usersData.uniqueId,
                //     audioChannel: 2
                //   },
                //   content: 'audio-channel',
                //   isBroadcast: true,
                //   sender: 'mobile'
                // };
                // this.sendDataToSocket(message);
              }
            }
          }
        }
      })
    }
    var _this = this;

    if (isMixerMuteByDefault) {
      if (usersData) {
        if (usersData.isMuteMySelf) {
          this.handleMySound()
        }
      }
      dispatch(setIsMixerMuteByDefault(false))
    }
  }

  componentDidUpdate(prevProps) {
    const { endRoomData, usersData, dispatch, delayPanning } = this.props;

    if (prevProps.endRoomData !== endRoomData) {
      if (endRoomData) {
        this.props.changePopupState('');
        setTimeout(() => {
          dispatch(saveRoomEndValue(null));
          dispatch(setUsersData(null));
          // UPDATE REDUCER FOR GHOST VOICESYNC:
          dispatch(setGhostVoiceSync(false));
          dispatch(closeVideoCall({ closeVideo: false }));
        }, 1000)
      }
    }
    if (prevProps.usersData !== usersData) {
      if (usersData != null) {
        const { users } = usersData;
        if (users) {
          this.setState({
            usersArr: users,
            sliderReverbValue: usersData?.reverbLevel,
            leftReverb: usersData?.leftReverb,
            rightReverb: !usersData?.leftReverb,
          });
        }
      } else {// IN DOUBT
        this.props.changePopupState('');
      }
    }
    // Check status of delay panning
    // with event
    // if (prevProps.delayPanning != delayPanning) {
    //   dispatch(setDelayPanning(delayPanning));

    //   let value = "";
    //   if (delayPanning == true) {
    //     value = 1;
    //   } else if (delayPanning == false) {
    //     value = 0;
    //   }
    //   const message = {
    //     action: {
    //       uniqueID: usersData.uniqueId,
    //       audioChannel: value
    //     },
    //     content: 'audio-channel',
    //     isBroadcast: true,
    //     sender: 'mobile'
    //   };
    //   this.sendDataToSocket(message);


    // }
  }

  componentWillUnmount() {
  }

  sendDataToSocket(message) {
    sendData(message);
  }

  // VALIDATE IP ADDRESS
  _ValidateIPaddress(ipaddress) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
      return (true)
    } else {
      return (false)
    }
  }

  // handle moderator mute control click button:-
  handleModeratorMuteControl(item, index) {
    const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

    let jitsiModerator = false;
    if (getLocalParticipant.role == 'moderator') {
      if (recordingStarted == 1 || streamingStarted == 1) {
        jitsiModerator = true;
      }
    }

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }

    const message = {
      action: {
        // index: item.index ? item.index : index,
        index: setIndex,
        ipAddress: roomorIpAddress,
        name: (item.name == 'me' || item.name == 'Me'
          || item.name == 'ME') ?
          usersData.myName : item.name,
        mute: !item.mutedByHost,
        jitsiModerator
      },
      content: 'moderator-control',
      isBroadcast: true,
      sender: 'mobile'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: '',
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);

    usersData.mutedByHost = !usersData.mutedByHost;
    this.setState({ usersData: usersData });
    sendAnalytics({
      action: 'mute-selected-user',
      source: "webjam",
      category: "mute selected user"
    });
  }

  handleMute(item, index) {
    const { usersArr } = this.state;
    const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

    let jitsiModerator = false;
    if (getLocalParticipant.role == 'moderator') {
      if (recordingStarted == 1 || streamingStarted == 1) {
        jitsiModerator = true;
      }
    }

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }

    const message = {
      action: {
        // index: item.index ? item.index : index,
        index: setIndex,
        faderLevel: item.volumeLevel,
        isMute: !item.isMute,
        isSolo: item.isSolo,
        uniqueID: usersData.uniqueId,
        ipAddress: roomorIpAddress,
        jitsiModerator
      },
      content: 'setting-to-app',
      isBroadcast: true,
      sender: 'mobile'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: message.action.uniqueID,
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);
    usersArr[index].isMute = !item.isMute;
    this.setState({ usersArr: usersArr });
    sendAnalytics({
      action: 'mute-other',
      source: "webjam",
      category: "mute other"
    });
  };

  handleSound(item, index) {
    const { usersArr } = this.state;
    const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

    let jitsiModerator = false;
    if (getLocalParticipant.role == 'moderator') {
      if (recordingStarted == 1 || streamingStarted == 1) {
        jitsiModerator = true;
      }
    }

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }

    const message = {
      action: {
        // index: item.index ? item.index : index,
        index: setIndex,
        faderLevel: item.volumeLevel,
        isMute: item.isMute,
        isSolo: !item.isSolo,
        uniqueID: usersData.uniqueId,
        ipAddress: roomorIpAddress,
        jitsiModerator
      },
      content: 'setting-to-app',
      isBroadcast: true,
      sender: 'mobile'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: message.action.uniqueID,
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);
    usersArr[index].isSolo = !item.isSolo;
    this.setState({ usersArr: usersArr });
    sendAnalytics({
      action: 'solo',
      source: "webjam",
      category: "solo"
    });
  };

  handleMySound() {
    const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

    let jitsiModerator = false;
    if (getLocalParticipant.role == 'moderator') {
      if (recordingStarted == 1 || streamingStarted == 1)
        jitsiModerator = true;
    }

    const message = {
      action: {
        isMuteMySelf: !usersData.isMuteMySelf,
        uniqueID: usersData.uniqueId,
        ipAddress: roomorIpAddress,
        jitsiModerator
      },
      content: 'mute-myself',
      isBroadcast: true,
      sender: 'mobile'
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: message.content,
      requestData: message,
      responseData: '',
      userId: '',
      boxId: message.action.uniqueID,
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);
    usersData.isMuteMySelf = !usersData.isMuteMySelf;
    this.setState({ usersData: usersData });
  };

  changeFader(value, index, item) {
    const { usersArr } = this.state;
    const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

    let jitsiModerator = false;
    if (getLocalParticipant.role == 'moderator') {
      if (recordingStarted == 1 || streamingStarted == 1) {
        jitsiModerator = true;
      }
    }

    displayConsole('index', index);
    usersArr[index].volumeLevel = value == 1 ? 0
      : value == 2 ? 12
        : value == 3 ? 25
          : value == 4 ? 37
            : value == 5 ? 50
              : value == 6 ? 63
                : value == 7 ? 75
                  : value == 8 ? 87 : 100;

    this.setState({ usersArr: usersArr });
    let faderLevel = 0;
    if (value && value == 1) {
      faderLevel = 0;
    } else if (value && value == 2) {
      faderLevel = 12;
    } else if (value && value == 3) {
      faderLevel = 25;
    } else if (value && value == 4) {
      faderLevel = 37;
    } else if (value && value == 5) {
      faderLevel = 50;
    } else if (value && value == 6) {
      faderLevel = 63;
    } else if (value && value == 7) {
      faderLevel = 75;
    } else if (value && value == 8) {
      faderLevel = 87;
    } else if (value && value == 9) {
      faderLevel = 100;
    }

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }

    const message = {
      action: {
        // index: item.index ? item.index : index,
        index: setIndex,
        faderLevel,
        isMute: item.isMute,
        isSolo: item.isSolo,
        uniqueID: usersData.uniqueId,
        ipAddress: roomorIpAddress,
        jitsiModerator
      },
      content: 'setting-to-app',
      isBroadcast: true,
      sender: 'mobile'
    };

    let this_ = this;
    if (timeoutFader) {
      clearTimeout(timeoutFader);
    }
    timeoutFader = setTimeout(function () {

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: message.action.uniqueID,
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1000)
  }

  onOpenModal = () => {
    this.setState({ open: true });
    sendAnalytics({
      action: 'settings-popup',
      source: "webjam",
      category: "settings popup"
    });
  };

  onCloseModal = () => {
    this.stopLatency();
    this.setState({ open: false });
  };

  stopLatency = () => {
    const { usersData } = this.props;

    const data = {
      action: {
        uniqueID: usersData.uniqueId
      },
      content: 'stop-latency',
      isBroadcast: true,
      sender: 'mobile'
    }

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: '',
      triggeredBy: 'system',
      event: data.content,
      requestData: data,
      responseData: '',
      userId: '',
      boxId: data.action.uniqueID,
      message: 'Emit to server'
    }
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(data);
  }

  changeSliderReverb(value) {
    const { usersData } = this.props;
    this.setState({
      sliderReverbValue: value,
    });

    const message = {
      action: {
        leftValue: this.state.leftReverb,
        reverbValue: value,
        uniqueID: usersData.uniqueId
      },
      content: 'set-reverb',
      isBroadcast: true,
      sender: 'mobile'
    };

    let this_ = this;
    if (timeoutFader) {
      clearTimeout(timeoutFader);
    }
    timeoutFader = setTimeout(function () {

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: message.action.uniqueID,
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500)
  }

  changeReverbLeftRadio() {
    const { usersData } = this.props;
    this.setState({
      leftReverb: true,
      rightReverb: false
    });

    const message = {
      action: {
        leftValue: true,
        reverbValue: this.state.sliderReverbValue,
        uniqueID: usersData.uniqueId
      },
      content: 'set-reverb',
      isBroadcast: true,
      sender: 'mobile'
    };

    let this_ = this;
    if (timeoutFader) {
      clearTimeout(timeoutFader);
    }
    timeoutFader = setTimeout(function () {

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: message.action.uniqueID,
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500)
  }

  changeReverbRigtRadio() {
    const { usersData } = this.props;
    this.setState({
      rightReverb: true,
      leftReverb: false
    });

    const message = {
      action: {
        leftValue: false,
        reverbValue: this.state.sliderReverbValue,
        uniqueID: usersData.uniqueId
      },
      content: 'set-reverb',
      isBroadcast: true,
      sender: 'mobile'
    };

    let this_ = this;
    if (timeoutFader) {
      clearTimeout(timeoutFader);
    }
    timeoutFader = setTimeout(function () {

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: message.action.uniqueID,
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500)
  }

  changeCircleSlider(value, index, item) {
    const { usersArr } = this.state;
    const { usersData } = this.props;

    usersArr[index].panValue = value ? value : 0;
    this.setState({ usersArr: usersArr });

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }

    const message = {
      action: {
        panValue: value,
        uniqueID: usersData.uniqueId,
        // index: item.index ? item.index : index
        index: setIndex
      },
      content: 'set-pan',
      isBroadcast: true,
      sender: 'mobile'
    };

    let this_ = this;
    if (timeoutFader) {
      clearTimeout(timeoutFader);
    }
    timeoutFader = setTimeout(function () {

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: '',
        triggeredBy: 'system',
        event: message.content,
        requestData: message,
        responseData: '',
        userId: '',
        boxId: message.action.uniqueID,
        message: 'Emit to server'
      }
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500);
  }

  onOpenPanModal(item, index) {
    sessionStorage.setItem("selectedIndex", index);

    let setIndex = item.index;
    if (setIndex == null || setIndex == undefined) {
      setIndex = index;
    }


    this.setState({
      openPan: true,
      selectedIndex: setIndex,
      userIndex: index
    });

    sendAnalytics({
      action: 'FX popup',
      source: "webjam",
      category: "webjam FX popup"
    });
  };

  onClosePanModal = () => {
    this.setState({ openPan: false });
  };

  closeWebjam = () => {
    const { changePopupState } = this.props;
    changePopupState('');
    dispatch(setDeviceContainerStatus("closeWebjamMixer", 'WebjamMixer'));
    dispatch(showMixerSettingsModal(false))
  };

  handleScroll = (e) => {
    this.setState({
      scrollClassName: 'fader-scroll'
    })
  };

  sliderScroll = (e) => {
    if (e.type == "mousedown") {
      this.setState({
        scrollClassName: 'fader-up-down'
      })
    }

    if (e.type == "mouseup") {
      this.setState({
        scrollClassName: ''
      })
    }
  };

  handleMixerName = (name) => {
    if (name.toLowerCase() === "me") {
      return ct("rta-trmc.mixer.me")
    }

    return name;
  }

  handleP2P = () => {
    const { p2pEnabled } = this.state
    dispatch(setConfirmationModalProps({
      isShow: true,
      title: "P2P Mode",
      content: "P2P is peer-to-peer, type of computer network often used for the distribution of digital media files. In a peer-to-peer (P2P) network, each computer acts as both a server and a client—supplying and receiving files—with bandwidth and processing distributed among all members of the network.",
      successBtnName: p2pEnabled ? "Disable" : "Enable",
      cancelBtnName: "Cancel",
      onSuccess: () => {
        this.setState({
          p2pEnabled: !p2pEnabled
        })
        dispatch(setConfirmationModalProps({ isShow: false }));
      },
      onCancel: () => {
        dispatch(setConfirmationModalProps({ isShow: false }));
      }
    }));
  }

  render() {
    const { open, usersArr, sliderReverbValue, leftReverb, rightReverb, openPan, scrollClassName, p2pEnabled } = this.state; //sliderPanValue
    const { usersData, changePopupState, prejoinScreenDetail, conferenceJoined } = this.props;
    const settings = getBaseConfig("settingsImage");

    let { localUserName } = this.props;
    // if (!localUserName) localUserName = "RTA User";
    // if (!localUserName) localUserName = filterRemoteParticipant(2);
    if (!localUserName) localUserName = getBaseConfig("userName");

    // don't show loader when checking device status/connectivity on prejoin screen
    if (prejoinScreenDetail.isSet) {
      return null;
    }

    if (!conferenceJoined) return null;

    if (!usersData) return null;

    let faderClass = 'row maxplayer flex-nowrap overflow-auto mixer-modal ' + scrollClassName;
    let p2pLogo = p2pEnabled ? "images/logo/rta_p2p_enabled.png" : "images/logo/rta_p2p_disabled.png"
    return <div>
      <BootstrapDialog
        // tabIndex={-1}
        className='mixer-popup-wrapper'
        fullWidth={true}
        maxWidth="md"
        data-testid="mixer-tab"
        id='mixer-tab'
        // onClose={handleClose}
        // aria-labelledby="customized-dialog-title"
        open={true}
        onClose={() => this.closeWebjam()}
      >
        <DialogContent dividers className='dialog-content-wrapper mixer-dialog-content-wrapper'>

          {usersData ?
            <div className="container-fluid mixer maxplayer_ui">
              <span id="close-mixer-modal" className="close" onClick={() => {
                this.closeWebjam()
              }}>
                <img src={cross} />
              </span>
              <div onScroll={this.handleScroll} className={faderClass}>
                {getBaseConfig("p2pMode") &&
                  <div className='p2p-wrapper' onClick={() => this.handleP2P()}>
                    <div className='p2p-logo'>
                      <img id="p2p-mode" class="col-img2" src={p2pLogo} />
                    </div>
                    <label className='p2p-text'>P2P Mode</label>
                  </div>
                }
                <div className="col-1 d-flex flex-column justify-content-end firt-child1">

                  <div className="col-d1 maxplayer-volum">
                    <Mic
                      active={!usersData.isMuteMySelf}
                      onClick={() => this.handleMySound()}
                    />
                  </div>
                  <div className="col-d2 maxplayer-volum">
                    <div style={{ position: 'relative' }}>
                      <MixerTooltip className="custom-tooltip-mixer" content={ct("Translate.tooltipContent.settingsLabel")} position="bottom">
                        <img id="mixer-setting" className="col-img2" src={settings} onClick={this.onOpenModal} />
                      </MixerTooltip>
                    </div>
                  </div>
                </div>

                {usersArr && usersArr.length > 0 && usersArr
                  // .sort((a, b) => a.name.toLowerCase() == 'me' ? -1 : 1) // this is creating issue
                  .map((data, index) => {
                    return (
                      // <div key={index.toString()} className="col-1 fix-player-width">
                      <div key={index.toString()} className={"col-1 fix-player-width " + (open || openPan ? "setting-container-opened" : "")} >
                        <div className="main-heading">
                          <div className="inner-head">
                            <span className="heading-s1" name={usersData.myName} local={localUserName}>
                              {this.handleMixerName(data.name)}
                              {data.name == 'me' || data.name == 'Me' || data.name == 'ME' ? " (" + ((usersData.myName != localUserName) ? localUserName : usersData.myName) + ")" : ""}
                            </span>
                            <span className="heading-s2">
                              {/* {instrumentArray[data.instrument]} */}
                              {this.handleInstrumentList(instrumentArray[data.instrument])}
                            </span>
                          </div>

                          <div className="d user-list-max">
                            <div className="d1 mixer-player">
                              <Mute
                                active={data.isMute}
                                onClick={() => this.handleMute(data, index)}
                              />
                              <Solo
                                active={data.isSolo}
                                onClick={() => this.handleSound(data, index)}
                              />

                              {(usersData.audioChannel != 0 && data.panValue !== 0) || (usersData?.reverbLevel != 0 && (data.name == 'me' || data.name == 'Me' || data.name == 'ME')) ?
                                <Fx active={true} onClick={() => this.onOpenPanModal(data, index)} />
                                :
                                <Fx active={false} onClick={() => this.onOpenPanModal(data, index)} />
                              }
                              {usersData && usersData?.isHost &&
                                <div className='muteIcon' style={{ position: 'relative' }}>
                                  <MMute
                                    active={data.mutedByHost}
                                    onClick={() => this.handleModeratorMuteControl(data, index)}
                                  />
                                </div>}

                            </div>

                            <div className="d2">
                              <Slider className="sldr-mxr"
                                onChangeStart={this.sliderScroll}
                                onChangeComplete={this.sliderScroll}
                                min={1}
                                max={9}
                                name='vertical'
                                orientation='vertical'
                                value={
                                  data.volumeLevel == 0 ? 1
                                    : data.volumeLevel == 12 ? 2
                                      : data.volumeLevel == 25 ? 3
                                        : data.volumeLevel == 37 ? 4
                                          : data.volumeLevel == 50 ? 5
                                            : data.volumeLevel == 63 ? 6
                                              : data.volumeLevel == 75 ? 7
                                                : data.volumeLevel == 87 ? 8 : 9
                                }
                                onChange={(value) => {
                                  this.changeFader(value, index, data);
                                }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </div>

              {open && <Settings tabindex="-1" onClose={this.onCloseModal} />}
              {openPan && <Fxtabs tabindex="-1" onClose={this.onClosePanModal} selectedIndex={this.state.selectedIndex} userIndex={this.state.userIndex} />}
            </div>
            : null}
        </DialogContent>
      </BootstrapDialog>
    </div>
  }
}

function _mapStateToProps(state) {

  return {
    // ..._abstractMapStateToProps(state),
    usersData: state[FEATURE_CUSTOM_REDUX].usersData,
    endRoomData: state[FEATURE_CUSTOM_REDUX].endRoomData,
    textMessage: state['trmc/customLoader/modal'].textMessage,
    getLocalParticipant: getLocalParticipant(state),
    roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
    isHybridSession: state[FEATURE_CUSTOM_REDUX].isHybridSession,
    uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
    hostTabData: state[FEATURE_CUSTOM_REDUX].hostTabData,
    delayPanning: state[FEATURE_CUSTOM_REDUX].delayPanning,
    recordingStarted: state[FEATURE_CUSTOM_REDUX].recordingStarted,
    streamingStarted: state[FEATURE_CUSTOM_REDUX].streamingStarted,
    localUserName: state['features/base/participants'].local?.name,
    localUser: state['features/base/participants'].local,
    prejoinScreenDetail: state[FEATURE_CUSTOM_REDUX_V2].prejoinScreenDetail,
    conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
    isMixerMuteByDefault: state[FEATURE_CUSTOM_REDUX_V3].isMixerMuteByDefault,
  };
}

export default translate(connect(_mapStateToProps)(WebjamMixer));

export const MixerTooltip = ({ children, content }) => {
  return <Tooltip disableFocusListener id='mui-custom-tooltip' title={content} placement="top" >{children}</Tooltip>
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paper': {
    margin: '0px'
  },
  '& .MuiDialog-paperFullWidth': {
    width: 'calc(100% - 20px )'
  },
  '& .MuiDialog-scrollPaper': {
    width: '100%'
  },
  '& .dialog-content-wrapper': {
    border: 'none'
  }
}));

